import { render, staticRenderFns } from "./SearchesStats.vue?vue&type=template&id=70c8309f&"
import script from "./SearchesStats.vue?vue&type=script&lang=js&"
export * from "./SearchesStats.vue?vue&type=script&lang=js&"
import style0 from "./SearchesStats.vue?vue&type=style&index=0&id=70c8309f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports